<template>
    <div>
        <edit-669-report-dialog
            v-model="dialogVisible"
            :modelProp="selectedReport"
            :constants="constants"
            @successful-report-save="handleSuccessfulReportSave"
        ></edit-669-report-dialog>

        <h4 class="tw-text-secondary mt-3 mb-3">Production Report 669</h4>
        <smart-table
            :items="productionReports"
            :headers="tableHeaders"
            :search="search"
            :loading="loading"
            @fetch-complete="onFetchComplete"
            @click:row="editReport"
            ref="datatable"
        >
            <template #item.report_name="{ item }">{{ item.report_name }}</template>
            <template #item.report_date="{ item }">{{ item.report_date }}</template>
        </smart-table>

        <!-- Button to open dialog -->
        <v-btn class="main-btn" @click="openDialog">Upload Report</v-btn>

    </div>
</template>

<script>

import SmartTable from "@/Generic/SmartTable";
import axios from "axios";
import Edit669ReportDialog from "@/Modals/Edit669ReportDialog";

export default {
    name: "WebsiteContentProductionReport669",
    components: {
        SmartTable,
        Edit669ReportDialog
    },

    data() {
        return {
            productionReports: [],
            search: "",
            loading: false,
            tableHeaders: [
                { text: "Filename", value: "report_name" },
                { text: "Date", value: "report_date", sortable: true, sortDesc: true }
            ],
            dialogVisible: false,
            selectedReport: null, // To store the selected report for editing
            constants: {

            }
        };
    },

    computed: {

    },
    methods: {
        async fetchProductionReports() {
            try {
                this.loading = true;
                const response = await axios.get("/production-reports/669")
                this.productionReports = response.data
            } catch (error) {
                console.error("Error fetching production reports:", error)
            } finally {
                this.loading = false
            }
        },
        onFetchComplete(response) {
            console.log("Fetch complete:", response)
        },
        openDialog() {
            this.selectedReport = null // Reset the selected report
            this.dialogVisible = true // Show the dialog
        },
        closeDialog() {
            this.dialogVisible = false // Hide the dialog
        },
        editReport(report) {
            this.selectedReport = report // Set the selected report
            this.dialogVisible = true // Show the dialog
        },
        handleSuccessfulReportSave() {
            this.fetchProductionReports()
        },
    },

    mounted() {
        this.fetchProductionReports()
    },
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
